module.exports = __webpack_public_path__ + "img/ship.a8a872fe.png";